import ReactGA from 'react-ga4';

const GoogleAnalytics = {
  initialize: () => {
    if (ReactGA && process.env?.REACT_APP_ENV === 'production') {
      const GA_ID = process.env?.REACT_APP_GA_ID ?? '';
      ReactGA.initialize([
        {
          trackingId: String(GA_ID)
        }
      ]);
    } else {
      console.error('Google Analytics not available');
    }
  },
  trackPageView: () => {},

  trackEvent: () => {},

  identifyUser: () => {}
};

export default GoogleAnalytics;
